import bylawModel from 'data/zoning_sidebar.json';
import bylawLegend from 'data/bl-legend.json';
import blankLegend from 'data/blank-legend.json';
import EventsLoggingService from 'js/EventsLoggingService';
import { getHandlerFor } from 'client/utils/angular';

const { EventTypes } = EventsLoggingService;

export default function ($scope, $window, ngDialog, $rootScope, authenticationService, USER_ROLES, $q, sidebarService) {
  $scope.bylawSidebar = Object.assign({}, bylawModel);
  $scope.byLaw = false;
  $scope.bylawTog = false;
  $scope.sameFormer = false;
  $scope.zformerTog = false;
  $scope.coverTog = false;
  $scope.heightTog = false;
  $scope.policyTog = false;
  $scope.roomingTog = false;
  $scope.fbtTog = false;
  //Bylaw Hide Vars
  $scope.bylawOn = false;

  const update = ({ bylawzonelayer: bylawZoneLayer, zformerarray: zformer_result, bylawzonereg: bylawZoneReg, zonecoverage: zoneCoverage,
                    zoneheight: zoneHeight, zonepolicy: zonePolicy, zoneroominghouse: zoneRoomingHouse,
                     }) => {
    //Check if there is ByLaw Information
    if ('no_result' in bylawZoneLayer) {
      //There is no bylaw
      $scope.bylawOn = false;
      $scope.bylawSidebar.bylawInfo.error = bylawZoneLayer.no_result;

      if ($scope.myp_municipality != 'Toronto') {
        $scope.bylawSidebar.bylawInfo.error = "Our Platform currently does not provide information in this area.";
      };

    } else if ('error' in bylawZoneLayer) {
      //There is no bylaw but, we need this to be on because the other functions may be using.
      $scope.bylawOn = false;
      $scope.bylawSidebar.bylawInfo.error = bylawZoneLayer.error;
    } else {
      //There is bylaw
      $scope.bylawOn = true;
      //Set By Law Zone Layer Information
      $scope.bylawSidebar.bylawZoneLayer = bylawZoneLayer;
    }

    //Check if there is By Law Zone Reg info
    if (bylawZoneReg.length == 0) {

    } else {
      //Set By Law Zone Reg Info
      $scope.bylawSidebar.bylawZoneReg = bylawZoneReg;

      var perm_num = $scope.createArray($scope.bylawSidebar.bylawZoneReg.length);//Array to hold how many perm info is in each by law zone reg
      var perm_sum_total = 0; //Hold value of total number of perm info from perm_num array

      for (var i = 0; i < $scope.bylawSidebar.bylawZoneReg.length; i++) {
        //Create array that will hold boolean values to determine if Show More button is needed
        $scope.hasPermInfo = $scope.createArray($scope.bylawSidebar.bylawZoneReg.length);

        //Add index data to array
        $scope.bylawSidebar.bylawZoneReg[i].index = i;

        for (const element of $scope.bylawSidebar.bylawZoneReg[i].myp_policy_description) {
          if (element.items) {
            //get number of permitted use for each bylaw zone reg
            perm_num[i] = element.items.length;
          }
        }
      }

      //aggregate total number
      for (var j = 0; j <= perm_num.length; j++) {
        perm_sum_total = perm_sum_total + perm_num[j];
      }

      //Create arrays for By Law info & By Law size
      $scope.infoBylawShown = $scope.createArray($scope.bylawSidebar.bylawZoneReg.length, perm_sum_total);
      $scope.infoBylawSize = $scope.createArray($scope.bylawSidebar.bylawZoneReg.length, perm_sum_total);

      //Set the limit for the list dynamically (By Law)
      $scope.infoLimitBylaw = function (index,parent) {
        if($scope.infoBylawShown[parent][index] === undefined){
          $scope.infoBylawShown[parent][index] = 1;
          $scope.infoBylawSize[parent][index] = 3;
          $scope.hasPermInfo[parent] = true;

          return $scope.infoBylawSize[parent][index];
        } else {
          return $scope.infoBylawSize[parent][index] * $scope.infoBylawShown[parent][index];
        }
      };

      //Check if there is more info to show
      $scope.hasMoreInfoToShowBylaw = function (index,parent) {
        if($scope.infoBylawShown[parent][index] === undefined)
          return 1 < ($scope.bylawSidebar.bylawZoneReg[index].myp_policy_description[index].items.length / 1);
        else
          return $scope.infoBylawShown[parent][index] < ($scope.bylawSidebar.bylawZoneReg[parent].myp_policy_description[index].items.length / $scope.infoBylawShown[parent][index]);
      };

      //Show more information
      $scope.showMoreInfoBylaw = function(index,parent){
        $scope.infoBylawShown[parent][index] = $scope.bylawSidebar.bylawZoneReg[parent].myp_policy_description[index].items.length;
        $scope.hasPermInfo[parent] = $scope.hasMoreInfoToShowBylaw(index,parent);
      };
    }

    //Check if there is Former Zoning info
    if ('no_result' in zformer_result) {
      $scope.zformerOn = false;
      $scope.bylawSidebar.formertoronto[0].error = zformer_result.no_result;
    } else if ('error' in zformer_result) {
      $scope.zformerOn = false;
      $scope.bylawSidebar.formertoronto[0].error = zformer_result.error;
    } else {
      //Set Zone Former Info
      $scope.bylawSidebar.formertoronto[1] = zformer_result;
      $scope.zformerOn = true;
    }

    //Check if there is Zone Coverage info
    if ('no_result' in zoneCoverage) {
      $scope.coverageOn = false;
      $scope.bylawSidebar.zoneCoverage.error = zoneCoverage.no_result;
    } else if ('error' in zoneCoverage) {
      $scope.coverageOn = false;
      $scope.bylawSidebar.zoneCoverage.error = zoneCoverage.error;
    } else {
      //Set Zone Coverage Info
      $scope.bylawSidebar.zoneCoverage = zoneCoverage;
      $scope.coverageOn = true;
    }

    //Check if there is Zone Height info
    if ('no_result' in zoneHeight) {
      $scope.heightOn = false;
      $scope.bylawSidebar.zoneHeight.error = zoneHeight.no_result;
    } else if ('error' in zoneHeight) {
      $scope.heightOn = false;
      $scope.bylawSidebar.zoneHeight.error = zoneHeight.error;
    } else {
      $scope.bylawSidebar.zoneHeight = zoneHeight;
      $scope.heightOn = true;
    }

    //Check if there is Zone Policy Info
    if ('no_result' in zonePolicy) {
      $scope.zonePolicyOn = false;
      $scope.bylawSidebar.zonePolicy.error = zonePolicy.no_result;
    } else if ('error' in zonePolicy) {
      $scope.zonePolicyOn = false;
      $scope.bylawSidebar.zonePolicy.error = zonePolicy.error;
    } else {
      //Set Zone Policy info
      $scope.bylawSidebar.zonePolicy = zonePolicy;
      $scope.zonePolicyOn = true;
    }

    //Check if there is Zone Rooming House
    if ('no_result' in zoneRoomingHouse) {
      $scope.roomingOn = false;
      $scope.bylawSidebar.zoneRoomingHouse.error = zoneRoomingHouse.no_result;
    } else if ('error' in zoneRoomingHouse) {
      $scope.roomingOn = false;
      $scope.bylawSidebar.zoneRoomingHouse.error = zoneRoomingHouse.error;
    } else {
      //Set Zone Rooming House Info
      $scope.bylawSidebar.zoneRoomingHouse = zoneRoomingHouse;
      $scope.roomingOn = true;
    }

  };

  if ($scope.myp_municipality == 'Toronto') {
    if($scope.legendTitle != "by-law")
      $rootScope.$broadcast('map/setlegend', [bylawLegend, "by-law"]);
  } else {
    if($scope.legendTitle != "blank") {
      $rootScope.$broadcast('map/setlegend', [blankLegend, "blank"]);
    }
  }

  $scope.bylawLink = function(url){
    EventsLoggingService.clickedLink(EventTypes.CLICKED_LINK_ZONING_BY_LAW);
    $window.open(url,'_blank');
  };

  $scope.tooltip_bylaw = {title:'Click question mark for source',checked: true};

  if(!$scope.isSearchBar) {
    //reset bylaw on/off button if needed.
    $scope.bylawSidebar.bylaw[0].toggle = $scope.checkLayer($scope.bylawSidebar.bylaw[0].name);

    //reset bylaw on/off button if needed.
    $scope.bylawSidebar.formertoronto[0].toggle = $scope.checkLayer($scope.bylawSidebar.formertoronto[0].name);

    //reset coverage on/off button if needed.
    $scope.bylawSidebar.coverage[0].toggle = $scope.checkLayer($scope.bylawSidebar.coverage[0].name);

    //reset height on/off button if needed.
    $scope.bylawSidebar.height[0].toggle = $scope.checkLayer($scope.bylawSidebar.height[0].name);

    //reset policy on/off button if needed.
    $scope.bylawSidebar.policy[0].toggle = $scope.checkLayer($scope.bylawSidebar.policy[0].name);

    //reset rooming on/off button if needed.
    $scope.bylawSidebar.rooming[0].toggle = $scope.checkLayer($scope.bylawSidebar.rooming[0].name);

    if(!$scope.onSidebar) {
      sidebarService.sidebarInfo({
        type: "bylaw_sidebar",
        gid: $scope.sidebar.gid,
        myp_municipality: $scope.sidebar.myp_municipality
      }).success(update);
    }
  }

  $scope.isGdHelpAuthorized = $q.defer();

  authenticationService.getUser().then(function (response) {
    var userInfo = response.data;
    var isAuthorized = userInfo.acc_type === USER_ROLES.BASIC ||
      userInfo.acc_type === USER_ROLES.TRIAL ||
      userInfo.acc_type === USER_ROLES.PRO ||
      userInfo.acc_type === USER_ROLES.PREM ||
      userInfo.acc_type === USER_ROLES.BETA ||
      userInfo.acc_type === USER_ROLES.ADMIN;

    if (isAuthorized) {
      $scope.isGdHelpAuthorized.resolve();
    } else {
      $scope.isGdHelpAuthorized.reject();
    }
  });

  $scope.gdHelp = function(url){
    EventsLoggingService.clickedLink(EventTypes.CLICKED_LINK_ZONING_BY_LAW);

    $scope.isGdHelpAuthorized.promise.then(function () {
        ngDialog.open({
          templateUrl:'templates/google-drive-help.tpl.html',
          className:'ngdialog-theme-plain',
          scope: $scope
        });
        $scope.url_link = url;
      },
      function () {
        ngDialog.open({
          templateUrl:'templates/google-drive-insufficient-permissions.tpl.html',
          className:'ngdialog-theme-plain',
          scope: $scope
        });
      });
  };
  $scope.gdLink = function(){
    ngDialog.closeAll();
    var win = window.open($scope.url_link.concat('#list'), '_blank');
    win.focus();
  };

  //Turn off the dev app if it's turned on
  if($rootScope.isDev) {
    $rootScope.$broadcast('map/setinfocontent', [$rootScope.address, 'address']);
    $rootScope.$broadcast('map/openaddresswindow');
    $rootScope.$broadcast('map/recentermap');
    $rootScope.isDev = false;
    $rootScope.$broadcast('locationToggle');
  }

  const toggle = (status) => {
    $scope.bylawSidebar.bylaw[0].toggle = status;
    $scope.bylawSidebar.formertoronto[0].toggle = status;
    $scope.bylawSidebar.coverage[0].toggle = status;
    $scope.bylawSidebar.height[0].toggle = status;
    $scope.bylawSidebar.policy[0].toggle = status;
    $scope.bylawSidebar.rooming[0].toggle = status;
  };

  const reset = () => {
    $scope.bylawSidebar = Object.assign({}, bylawModel);
  };

  $rootScope.$on('sidebar/bylaw/update', getHandlerFor(update));
  $rootScope.$on('sidebar/bylaw/toggle', getHandlerFor(toggle));
  $rootScope.$on('sidebar/bylaw/reset', getHandlerFor(reset));

  return {
    update,
    toggle,
    reset
  };
};



// WEBPACK FOOTER //
// ./client/controllers/zoning_sidebar.js